import React from "react";
import { HeartPulse, Stethoscope, UserCheck, ShieldPlus, ArrowLeft, MessageCircle } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const services = [{
  id: "home-nursing",
  title: "טיפול סיעודי מקיף בבית",
  icon: HeartPulse,
  paragraphs: ["אנו מספקים מעטפת מלאה של שירותי סיעוד מקצועיים המותאמים אישית לצרכי המטופל, כולל הצבת מטפל סיעודי מוסמך בבית הלקוח.", "השירות כולל סיוע בפעולות היומיום (ADL) כגון רחצה, הלבשה, האכלה וניידות. ניתן לקבל שירותי מטפל סיעודי בתל אביב או השגחה בבית חולים במידת הצורך.", "מעבר לטיפול הפיזי, המטפלים שלנו מעניקים תמיכה רגשית וחברה. למידע נוסף קראו מאמר מקצועי על מטפל סיעודי בבית והזכויות המגיעות לכם."],
  trustText: "מטפלים מוסמכים עם תעודות יושר",
  ctaText: "לייעוץ חינם",
  ctaLink: "/ContactPage"
}, {
  id: "medical-supervision",
  title: "השגחה רפואית צמודה 24/7",
  icon: Stethoscope,
  paragraphs: ["במצבים רפואיים מורכבים הדורשים ניטור מתמיד, אנו מספקים מטפל סיעודי צמוד המנטור את המצב הרפואי ומעניק ביטחון מלא.", "השירות מתאים במיוחד לחולים לאחר ניתוחים מורכבים. הצוות זמין עבור מטפל סיעודי בתל אביב וגם עבור השגחה בבית חולים מסביב לשעון.", "הנוכחות המתמדת של איש מקצוע רפואי בבית מפחיתה סיבוכים. תוכלו למצוא מאמר מקצועי המסביר על יתרונות מטפל סיעודי בבית בחירום."],
  trustText: "פיקוח על ידי אחות ראשית",
  ctaText: "פרטים נוספים",
  ctaLink: "/ServicesCitiesArticlesPage"
}, {
  id: "post-hospitalization",
  title: "ליווי ושיקום לאחר אשפוז",
  icon: UserCheck,
  paragraphs: ["החזרה הביתה לאחר אשפוז ממושך דורשת ליווי של מטפל סיעודי מקצועי להבטחת החלמה מהירה ובטוחה בסביבה המוכרת.", "אנו מסייעים בהתאמת סביבת המגורים לצרכים החדשים. שירותי מטפל סיעודי בתל אביב כוללים גם השגחה בבית חולים פרטית וליווי צמוד.", "הצוות שלנו עובד בשילוב זרועות עם צוות השיקום. מומלץ לעיין בתוך מאמר מקצועי על תהליך מטפל סיעודי בבית לאחר ניתוח מורכב."],
  trustText: "תוכנית שיקום מותאמת אישית",
  ctaText: "תיאום פגישה",
  ctaLink: "/ContactPage"
}, {
  id: "private-nurse",
  title: "שירותי אחות פרטית מומחית",
  icon: ShieldPlus,
  paragraphs: ["כאשר נדרש טיפול רפואי מתקדם, אחות פרטית פועלת בתיאום עם מטפל סיעודי לשיפור המצב הבריאותי של המטופל.", "השירות כולל טיפול בפצעים ומתן עירויים. ניתן לתאם הגעת מטפל סיעודי בתל אביב או השגחה בבית חולים בכל עת שנדרש.", "היתרון העצום הוא מניעת חשיפה לזיהומים. לפרטים נוספים ראו מאמר מקצועי בנושא מטפל סיעודי בבית ושיקום רפואי מתקדם."],
  trustText: "אחיות מוסמכות משרד הבריאות",
  ctaText: "הזמנת אחות",
  ctaLink: "/ContactPage"
}];
const faqs = [{
  question: "תוך כמה זמן ניתן לקבל מטפל סיעודי?",
  answer: "אנו מתחייבים לספק מטפל סיעודי מקצועי תוך 5 שעות בלבד מרגע הפנייה, בפריסה ארצית מלאה."
}, {
  question: "מה היתרון של שכירת מטפל סיעודי פרטי?",
  answer: "מטפל סיעודי פרטי מעניק יחס אישי של אחד-על-אחד, התאמה מלאה ללוח הזמנים של המשפחה ושמירה על רמה גבוהה של מקצועיות ודיסקרטיות."
}, {
  question: "האם אתם מספקים מטפל סיעודי בבית גם בסופי שבוע?",
  answer: "בוודאי. שירותי מטפל סיעודי בבית זמינים 24/7, כולל שבתות וחגים, כדי להבטיח רצף טיפולי מלא."
}, {
  question: "האם המטפלים שלכם עוברים הכשרה רפואית?",
  answer: "כל מטפל סיעודי מטעמנו עובר סינון קפדני, בדיקת רקע והכשרות מקצועיות שוטפות בפיקוח אחות ראשית."
}];
export default function ServicesSummary() {
  const renderTextWithLinks = (text: string) => {
    const links = [{
      phrase: "מטפל סיעודי בתל אביב",
      to: "/NurseInTelAvivWithinHoursPage"
    }, {
      phrase: "מטפל סיעודי בירושלים",
      to: "/JerusalemPage"
    }, {
      phrase: "מטפל סיעודי בחיפה",
      to: "/HaifaPage"
    }, {
      phrase: "מטפל סיעודי בבית",
      to: "/ServicesCitiesArticlesPage"
    }, {
      phrase: "השגחה בבית חולים",
      to: "/NursingCareNowPage"
    }, {
      phrase: "מאמר מקצועי נוסף",
      to: "/AdditionalArticlePage"
    }, {
      phrase: "מאמר מקצועי",
      to: "/ProfessionalBlogPage"
    }, {
      phrase: "מטפל סיעודי",
      to: "/CaregiverServicePagesPage"
    }];
    let parts: (string | React.ReactNode)[] = [text];
    links.forEach(({
      phrase,
      to
    }) => {
      const nextParts: (string | React.ReactNode)[] = [];
      parts.forEach(part => {
        if (typeof part !== "string") {
          nextParts.push(part);
          return;
        }
        const segments = part.split(phrase);
        segments.forEach((segment, idx) => {
          if (segment !== "") nextParts.push(segment);
          if (idx < segments.length - 1) {
            nextParts.push(<Link key={`${phrase}-${idx}`} to={to} className="text-secondary hover:underline font-medium transition-colors">
                {phrase}
              </Link>);
          }
        });
      });
      parts = nextParts;
    });
    return parts;
  };
  return <section id="סיכום-שירותים" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-7xl">
        
        <div className="mb-16 text-right animate-in fade-in slide-in-from-bottom-4 duration-700">
          <h2 className="text-3xl md:text-5xl font-bold text-primary mb-8">
            שירותי סיעוד מקיפים – מטפל סיעודי שזמין עבורכם תמיד
          </h2>
          <div className="space-y-6 text-lg md:text-xl text-muted-foreground max-w-4xl leading-relaxed">
            <p>
              {renderTextWithLinks("בחירה במטפל סיעודי היא צעד משמעותי עבור כל משפחה המתמודדת עם אתגרים בריאותיים של יקירה. אנו ב-Siudy מבינים את האחריות הכבדה המוטלת על כתפיכם, ולכן אנו מציעים פתרונות מהירים המשלבים מטפל סיעודי בירושלים וכן מטפל סיעודי בחיפה המותאמים בדיוק לצרכים שלכם.")}
            </p>
            <p>
              {renderTextWithLinks("כאשר אתם מחפשים מטפל סיעודי פרטי, אתם מחפשים הרבה מעבר לסיוע טכני; אתם מחפשים שותף לדרך, מישהו שיעניק ביטחון, חברה ותמיכה רפואית ברמה הגבוהה ביותר. המטפלים שלנו הם ישראלים בלבד, בעלי ניסיון רב וגישה אמפתית. קראו מאמר מקצועי נוסף כדי להבין את היתרונות של הטיפול הפרטי.")}
            </p>
            <p>
              {renderTextWithLinks("השירות של מטפל סיעודי בבית מאפשר ליקירכם להישאר בסביבה המוכרת והאוהבת שלו, תוך קבלת כל הטיפול הנדרש ללא הצורך במעבר למוסדות חיצוניים. אנו כאן כדי להבטיח שאיכות החיים תישמר בכל מצב.")}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, i) => <Card key={service.id} data-index={i} className="bg-card rounded-[16px] shadow-[0_4px_20px_rgba(0,0,0,0.05)] border border-transparent hover:border-ring transition-all duration-300 hover:scale-[1.02] overflow-hidden flex flex-col">
              <CardHeader className="pb-4">
                <div className="w-14 h-14 rounded-xl bg-primary/5 flex items-center justify-center mb-4">
                  <service.icon className="w-7 h-7 text-secondary" strokeWidth={1.5} />
                </div>
                <CardTitle className="font-default font-medium text-2xl text-foreground">
                  {service.title}
                </CardTitle>
              </CardHeader>
              
              <CardContent className="flex-1 flex flex-col">
                <div className="space-y-4 text-[18px] font-sans text-muted-foreground leading-relaxed flex-1">
                  {service.paragraphs.map((paragraph, j) => <p key={j} data-index={j}>{renderTextWithLinks(paragraph)}</p>)}
                  <p>
                    {renderTextWithLinks("למידע נוסף על מטפל סיעודי בירושלים וקרא מאמר מקצועי נוסף על מטפל סיעודי בחיפה.")}
                  </p>
                </div>

                <div className="mt-8 pt-5 border-t border-[#64748B]/20 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                  <span className="text-sm font-medium text-[#64748B] dark:text-slate-400">
                    {service.trustText}
                  </span>
                  <Button variant="ghost" size="sm" asChild className="text-secondary hover:text-secondary/80 hover:bg-secondary/10 -ml-3 sm:ml-0">
                    <Link to={service.ctaLink} className="flex items-center">
                      <ArrowLeft className="w-4 h-4 ml-2" />
                      {service.ctaText}
                    </Link>
                  </Button>
                </div>
              </CardContent>
            </Card>)}
        </div>

        
        <div className="mt-24 bg-primary/5 rounded-3xl p-8 md:p-12 animate-in fade-in slide-in-from-bottom-8 duration-700">
          <h3 className="text-3xl font-bold text-primary mb-6">הפתרון שלנו: זמינות מיידית ומקצועיות ללא פשרות</h3>
          <div className="space-y-4 text-lg text-muted-foreground max-w-5xl">
            <p>
              {renderTextWithLinks("המחסור במטפלים זמינים בישראל הוא בעיה כאובה. אנו ב-Siudy פתרנו את הבעיה הזו באמצעות רשת רחבה של אנשי מקצוע המוכנים להצבה מהירה. אם אתם זקוקים ל**מטפל סיעודי** באופן דחוף, אנחנו הכתובת שלכם.")}
            </p>
            <p>
              {renderTextWithLinks("המודל שלנו מתבסס על התאמה אישית של מטפל סיעודי פרטי לכל מטופל, תוך התחשבות ברקע הרפואי, הצרכים הפיזיים והעדפות אישיות, כדי להבטיח חיבור אנושי מוצלח מהרגע הראשון.")}
            </p>
          </div>
        </div>

        
        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-16">
          <div className="animate-in fade-in slide-in-from-right-8 duration-700">
            <h3 className="text-2xl font-bold text-primary mb-6">היתרונות של מטפל סיעודי בבית</h3>
            <div className="space-y-4 text-lg text-muted-foreground">
              <p>
                {renderTextWithLinks("היתרון המרכזי של מטפל סיעודי בבית הוא השמירה על כבודו של המטופל. בסביבה ביתית, המטופל מרגיש בשליטה ונינוח יותר, מה שמאיץ תהליכי החלמה ומפחית מתחים נפשיים.")}
              </p>
              <p>
                {renderTextWithLinks("בנוסף, הטיפול הביתי מאפשר גמישות מקסימלית למשפחה, מניעת חשיפה לזיהומים במוסדות רפואיים, ומתן תשומת לב בלעדית שפשוט לא קיימת במחלקות עמוסות.")}
              </p>
            </div>
          </div>
          <div className="animate-in fade-in slide-in-from-left-8 duration-700">
            <h3 className="text-2xl font-bold text-primary mb-6">מידע מורחב על שירותי הסיעוד</h3>
            <div className="space-y-4 text-lg text-muted-foreground">
              <p>
                {renderTextWithLinks("שירותי הסיעוד שלנו כוללים השגחה רפואית, ניהול תרופות, סיוע בניידות ורחצה, וליווי לביקורים רפואיים. כל מטפל סיעודי פרטי מטעמנו נבחר לאחר תהליך מיון קפדני הכולל בדיקות רקע וראיונות עומק.")}
              </p>
              <p>
                {renderTextWithLinks("אנו מקפידים על שקיפות מלאה מול המשפחה, עם דיווחים שוטפים וזמינות של מנהל מקרה עבורכם בכל שאלה או צורך שעולה במהלך הטיפול.")}
              </p>
            </div>
          </div>
        </div>

        
        <div className="mt-32 max-w-4xl mx-auto">
          <h3 className="text-3xl font-bold text-primary mb-10 text-center">שאלות ותשובות נפוצות</h3>
          <div className="space-y-4">
            {faqs.map((faq, index) => <Card key={index} data-index={index} className="border-border/50 shadow-sm hover:border-secondary/50 transition-colors">
                <CardHeader className="py-5">
                  <CardTitle className="text-xl font-bold text-primary flex items-start gap-4">
                    <span className="w-8 h-8 rounded-full bg-secondary/10 text-secondary flex items-center justify-center shrink-0 text-sm">
                      ?
                    </span>
                    {faq.question}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pb-6 pr-16">
                  <p className="text-muted-foreground text-lg leading-relaxed" data-index={index}>
                    {renderTextWithLinks(faq.answer)}
                  </p>
                </CardContent>
              </Card>)}
          </div>
        </div>

        
        <div className="mt-20 text-center">
          <div className="inline-flex flex-col items-center gap-6 p-10 bg-secondary/5 rounded-[32px] border border-secondary/10">
            <h4 className="text-2xl font-bold text-primary">זקוקים למטפל סיעודי עכשיו?</h4>
            <div className="text-muted-foreground max-w-lg">
              {renderTextWithLinks("אל תחכו. המומחים שלנו זמינים לייעוץ ראשוני ללא התחייבות. נתאים לכם מטפל סיעודי מקצועי תוך שעות.")}
            </div>
            <Button size="lg" className="bg-secondary text-white hover:bg-secondary/90 px-12 py-7 text-xl rounded-full shadow-lg hover:scale-105 transition-transform" asChild>
              <Link to="#" className="flex items-center gap-3">
                <MessageCircle className="w-6 h-6" />
                צרו קשר לייעוץ חינם
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}